var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":""}},[_c('div',[_c('vue-element-loading',{attrs:{"active":_vm.loading,"color":"#00cca2","spinner":"spinner"}}),_c('ve-histogram',{attrs:{"data":_vm.item,"title":{
          text:("学员年龄分布（" + (_vm.item.title?_vm.item.title:'0') + "）"),
          subtext: ("累计至 " + _vm.end_date),
          textStyle: {
              fontSize: 15,
          },
          subtextStyle: {
              fontSize: 12.5
          }
      },"legend":{show:false},"judge-width":"","grid":{right: '5%'},"mark-line":_vm.markLine,"settings":{label: { show: true, position: 'top'},yAxisType: ['KMB', 'KMB']},"extend":{
          yAxis:{
              splitLine: {
              lineStyle: {
                  type: 'dotted'
              }
              }
          },
          series:{
              type:'bar',
              barMaxWidth: 10,
              itemStyle:{
                  normal:{
                      color: function(params) {
                          return {
                              type: 'linear',
                              x:1,
                              y:1,
                              x2:0,
                              y2:0,
                              colorStops: [{
                                  offset: 0,
                                  color: '#effffb'
                                  
                              }, {
                                  offset: 1,                    
                                  color: '#23d9ae'
                              }],
                          }
                      },
                      barBorderRadius:[30,30,0,0]
                  }
              }
      },
      dataZoom:[{type:'inside'}]}}}),(_vm.first>0 && _vm.item.rows.length == 0)?_c('LEmpty'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }